import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
    * {
        padding: 0;
        margin: 0;
        list-style: none;
        text-decoration: none;
        box-sizing: border-box;
    }

    html { 
        background-color: #eee;
        scroll-behavior: smooth;
    }

    

    .hybrid-viewport-wrap {
        width: 100vw;       /* área visível */
        height: 100vh;
        overflow: hidden;   /* evita barras quando em escala */
    }

    .hybrid-canvas {
        width: 1500px;      /* seu “canvas” fixo */
        /* altura opcional se quiser travar também:
            height: 900px;   */
        transform-origin: top left;
        /* quando não estiver escalando, permitimos rolagem interna se precisar */
        overflow: visible;
       }

    input:-webkit-autofill,
    input:-webkit-autofill:focus {
        transition: background-color 0s 600000s, color 0s 600000s !important;
    }

    .mp-autocomplete-fragment {
        color: #7f7f7f;
    }

`;
